

































































import Vue from 'vue'
import axios from 'axios'
import { Product, SubjectProducts } from '@/models/Product'
import ProductForm from '@/components/ProductForm.vue'

export default Vue.extend({
  name: 'Home',

  components: { ProductForm },

  data: () => ({
    showToTop: false,
    products: [] as Product[]
  }),

  computed: {
    subjects(): SubjectProducts[] {
      let current = new SubjectProducts('')
      return this.products.reduce((prev: SubjectProducts[], product: Product) => {
        const subject = product.subject
        if (subject === current.subject) {
          current.products.push(product)
        } else {
          current = new SubjectProducts(subject)
          current.products.push(product)
          prev.push(current)
        }
        return prev
      }, [])
    }
  },

  methods: {
    onClickToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onScroll(e: any) {
      const top = window.pageYOffset || (e.target && e.target.scrollTop) || 0
      this.showToTop = top > 300
    }
  },

  mounted() {
    window.addEventListener('scroll', this.onScroll)
    axios.get(`${process.env.VUE_APP_API_URL}products`).then((res) => {
      console.log(res.data)
      this.products = res.data.map((p: Product) => {
        return new Product(p.code, p.subject, p.knum, p.title, p.desc, p.enable)
      })
    })
  }
})
